import { COLLECTION_ACTION, COLLECTION_LIST } from "./Collection.action";

const intailreducer = {
  collectionList: [],
  editCollectionAction: false,
};

export const collectionReducer = (state = intailreducer, action) => {
  switch (action.type) {
    case COLLECTION_LIST:
      return { ...state, collectionList: action.value };
    case COLLECTION_ACTION:
      return { ...state, editCollectionAction: action.value };

    default:
      return state;
  }
};
